import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import {
  getCustomerToken, getWishlistSkus, refreshWishlist, subscribeWishlist, toggleWishlist,
} from "@/lib/account";

export function WishlistButton({ sku, className = "", testid }) {
  const navigate = useNavigate();
  const [skus, setSkus] = useState(getWishlistSkus());
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (skus === null) refreshWishlist().then(setSkus);
    return subscribeWishlist(setSkus);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const active = (skus || []).includes(sku);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!getCustomerToken()) {
      toast("Sign in to save pieces to your wishlist", { description: "Create a free account and get 10% off your first purchase." });
      navigate("/account");
      return;
    }
    setBusy(true);
    try {
      const added = await toggleWishlist(sku);
      toast.success(added ? "Saved to your wishlist" : "Removed from your wishlist");
    } catch {
      toast.error("Couldn't update your wishlist — please try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      aria-label={active ? "Remove from wishlist" : "Save to wishlist"}
      data-testid={testid}
      className={`inline-flex items-center justify-center rounded-full transition-colors duration-300 disabled:opacity-50 ${
        active ? "text-[#C9A227]" : "text-neutral-400 hover:text-[#C9A227]"
      } ${className}`}
    >
      <Heart size={18} strokeWidth={1.5} fill={active ? "#C9A227" : "none"} />
    </button>
  );
}
